import { useNavigate } from "react-router-dom";
import PageLayout from "@/components/site/PageLayout";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import CTABand from "@/components/site/CTABand";
import SEO from "@/components/site/SEO";

export default function Home() {
  const navigate = useNavigate();
  const toContact = () => navigate("/contact");
  return (
    <PageLayout testid="home-page">
      <SEO
        title="Invisible Grills in Hyderabad | Sudeeksha Invisible Grills"
        description="Premium invisible grill installation in Hyderabad for balconies, windows & staircases. Rust-free SS316 steel, child & pet safe, free site visit. Call +91 70325 07529."
        path="/"
      />
      <Hero onQuote={toContact} />
      <Marquee />
      <Services onQuote={toContact} />
      <CTABand />
    </PageLayout>
  );
}
